import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { DIRECTION_TYPES } from '../../../../constants';
import { formatPrice, getStorZebraExtraPrice } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';
import OrderMotorSection from './OrderMotorSection';

const StorZebraForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect,
  adminSettings,
  selectedProductType,
  handleMotorTypeChange
}) => {

  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input
          type="text"
          value={newOrder.roomName || ''}
          onChange={(e) => onFieldChange('roomName', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
            (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading}
          isClearable
          isSearchable
          placeholder="Ürün seçin veya yazın..."
          noOptionsMessage={() => "Ürün bulunamadı"}
          formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
          styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input
          type="text"
          value={newOrder.productVariant || ''}
          onChange={(e) => onFieldChange('productVariant', e.target.value)}
          disabled={isLoading}
          placeholder="Renk, desen vb. giriniz..."
        />
      </div>

      <div className="form-group">
        <label>Birim Fiyat (€) *</label>
        <input
          type="number"
          step="0.01"
          min="0"
          value={newOrder.unitPrice || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('unitPrice', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>En (cm) *</label>
        <input
          type="number"
          step="0.01"
          value={newOrder.width || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('width', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Boy (cm) *</label>
        <input
          type="number"
          step="0.01"
          value={newOrder.height || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('height', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Yön *</label>
        <select
          value={newOrder.direction || ''}
          onChange={(e) => onFieldChange('direction', e.target.value)}
          required
          disabled={isLoading}
        >
          <option value="">Seçiniz</option>
          {Object.entries(DIRECTION_TYPES).map(([key, value]) => (
            <option key={key} value={value}>{value}</option>
          ))}
        </select>
      </div>

      {newOrder.width && newOrder.usedM2 && (
        <div className="form-group">
          <label>Kullanılan Mt²</label>
          <input
            type="text"
            value={newOrder.usedM2}
            readOnly
            className="readonly-field"
          />
        </div>
      )}

      <OrderMotorSection
        newOrder={newOrder}
        onFieldChange={onFieldChange}
        adminSettings={adminSettings}
        selectedProductType={selectedProductType}
        isLoading={isLoading}
      />

      <div className="form-group">
        <label>Montaj (€)</label>
        <input
          type="number"
          step="0.01"
          value={newOrder.mounting || ''}
          onChange={(e) => onFieldChange('mounting', e.target.value)}
          disabled={isLoading}
        />
      </div>

      <div style={{ gridColumn: '1 / -1', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px', marginTop: '15px', marginBottom: '15px' }}>
        {selectedProductType === 'stor' && (
          <>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorJumbo || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorJumbo', checked); onFieldChange('storJumboAmount', checked ? getStorZebraExtraPrice('jumbo', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Jumbo Sistem</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('jumbo', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorAltEtekDilim || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorAltEtekDilim', checked); onFieldChange('storAltEtekDilimAmount', checked ? getStorZebraExtraPrice('altEtekDilim', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Dilim</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('altEtekDilim', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorKapaliKasa || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorKapaliKasa', checked); onFieldChange('storKapaliKasaAmount', checked ? getStorZebraExtraPrice('kapaliKasa', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Kapalı Kasa</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('kapaliKasa', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorAltEtekLazer || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorAltEtekLazer', checked); onFieldChange('storAltEtekLazerAmount', checked ? getStorZebraExtraPrice('altEtekLazer', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Lazer</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('altEtekLazer', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorDekoratifLama || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorDekoratifLama', checked); onFieldChange('storDekoratifLamaAmount', checked ? getStorZebraExtraPrice('dekoratifLama', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Dekoratif Lama</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('dekoratifLama', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorDekoratifKasa || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorDekoratifKasa', checked); onFieldChange('storDekoratifKasaAmount', checked ? getStorZebraExtraPrice('dekoratifKasa', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Dekoratif Kasa</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('dekoratifKasa', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasStorAltEtekBeyazIs || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasStorAltEtekBeyazIs', checked); onFieldChange('storAltEtekBeyazIsAmount', checked ? getStorZebraExtraPrice('altEtekBeyazIs', adminSettings, 'stor') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Beyaz İş</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('altEtekBeyazIs', adminSettings, 'stor')} €</small>
                </div>
              </label>
            </div>
          </>
        )}

        {selectedProductType === 'zebra' && (
          <>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZebraJumbo || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZebraJumbo', checked); onFieldChange('zebraJumboAmount', checked ? getStorZebraExtraPrice('jumbo', adminSettings, 'zebra') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Jumbo Sistem</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('jumbo', adminSettings, 'zebra')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZebraAltEtekDilim || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZebraAltEtekDilim', checked); onFieldChange('zebraAltEtekDilimAmount', checked ? getStorZebraExtraPrice('altEtekDilim', adminSettings, 'zebra') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Alt Etek Dilim</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('altEtekDilim', adminSettings, 'zebra')} €</small>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZebraKapaliKasa || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZebraKapaliKasa', checked); onFieldChange('zebraKapaliKasaAmount', checked ? getStorZebraExtraPrice('kapaliKasa', adminSettings, 'zebra') : 0); }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Kapalı Kasa</span>
                  <small style={{ color: '#b04309', fontSize: '11px' }}>{getStorZebraExtraPrice('kapaliKasa', adminSettings, 'zebra')} €</small>
                </div>
              </label>
            </div>
          </>
        )}
      </div>

      <div className="form-group">
        <label>Adet *</label>
        <input
          type="number"
          min="1"
          value={newOrder.quantity || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('quantity', e.target.value)}
          required
          disabled={isLoading}
          placeholder="Adet giriniz"
        />
      </div>

      <div className="form-group">
        <label>İskonto (%)</label>
        <input
          type="number"
          min="0"
          max="100"
          value={newOrder.discount || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('discount', e.target.value)}
          disabled={isLoading}
        />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (€)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}

      {newOrder.discount > 0 && (
        <div className="form-group">
          <label>İndirimli Tutar (€)</label>
          <input
            type="text"
            value={formatPrice(newOrder.discountedPrice)}
            readOnly
            className="readonly-field discounted-price"
          />
        </div>
      )}
    </>
  );
};

export default StorZebraForm;
